import { FC } from "react";


export type TColumnData = {
    text: string;
    width: number;
    classes?: string;
};

const TableColumn: FC<TColumnData>
    = ({
        text,
        width,
        classes,
    }) => {
        return (
            <div
                className={`flex p-3 border-r ${classes}`}
                style={{ width: `${width}%`, minWidth: `${width}%` }}
            >
                <span className="fs-14 font-semibold">{text}</span>
            </div>
        );
    }

export default TableColumn;